import React from 'react';

function FoxPoint(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={497.41}
      height={498.47}
      viewBox="0 0 497.41 498.47"
      {...props}
    >
      <defs>
        <linearGradient
          id="prefix__a"
          x1={208.7}
          y1={229.38}
          x2={276.58}
          y2={229.38}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#e45c90" />
          <stop offset={1} stopColor="#e62063" />
        </linearGradient>
        <linearGradient
          id="prefix__b"
          x1={243.04}
          y1={312.22}
          x2={265.78}
          y2={312.22}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#e45c90" />
          <stop offset={1} stopColor="#f09c60" />
        </linearGradient>
        <linearGradient
          id="prefix__c"
          x1={244.16}
          y1={158.7}
          x2={322.99}
          y2={158.7}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ef7f1e" />
          <stop offset={1} stopColor="#e62063" />
        </linearGradient>
        <linearGradient
          id="prefix__d"
          x1={209.39}
          y1={358.7}
          x2={210.95}
          y2={358.7}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#f09c60" />
          <stop offset={1} stopColor="#ef7f1e" />
        </linearGradient>
        <linearGradient
          id="prefix__e"
          x1={265.78}
          y1={267.82}
          x2={333.08}
          y2={267.82}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__f"
          x1={227.37}
          y1={154.67}
          x2={260.86}
          y2={154.67}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__g"
          x1={304.09}
          y1={353.05}
          x2={356.17}
          y2={353.05}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__h"
          x1={245.5}
          y1={354.33}
          x2={329.64}
          y2={354.33}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__i"
          x1={207.22}
          y1={288.46}
          x2={247.11}
          y2={288.46}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__j"
          x1={167.52}
          y1={460.64}
          x2={205.84}
          y2={460.64}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__k"
          x1={416.27}
          y1={424.29}
          x2={416.27}
          y2={424.29}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__l"
          x1={384.13}
          y1={481.96}
          x2={497.41}
          y2={481.96}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__m"
          x1={389.07}
          y1={440.32}
          x2={497.41}
          y2={440.32}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__n"
          x1={258.9}
          y1={445.9}
          x2={297.71}
          y2={445.9}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__o"
          x1={333.08}
          y1={313.5}
          x2={422}
          y2={313.5}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__p"
          x1={416.27}
          y1={416.92}
          x2={469.77}
          y2={416.92}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__q"
          x1={146.75}
          y1={85.41}
          x2={249.69}
          y2={85.41}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__r"
          x1={128.83}
          y1={99.27}
          x2={135.7}
          y2={99.27}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__s"
          x1={356.17}
          y1={378.6}
          x2={422}
          y2={378.6}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__t"
          x1={119.99}
          y1={72.17}
          x2={120.02}
          y2={72.17}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__u"
          x1={383.68}
          y1={483.24}
          x2={497.41}
          y2={483.24}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__v"
          x1={152.28}
          y1={419.79}
          x2={209.03}
          y2={419.79}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__w"
          x1={157.93}
          y1={266.78}
          x2={214.68}
          y2={266.78}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__x"
          x1={389.08}
          y1={464.72}
          x2={399.6}
          y2={464.72}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__y"
          x1={164.46}
          y1={209.59}
          x2={227.37}
          y2={209.59}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__z"
          x1={226.73}
          y1={401.06}
          x2={231.07}
          y2={401.06}
          gradientTransform="rotate(77.38 228.902 401.069)"
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aa"
          x1={226.73}
          y1={396.05}
          x2={300.09}
          y2={396.05}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ab"
          x1={297.71}
          y1={440.99}
          x2={365.01}
          y2={440.99}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__ac"
          x1={270.2}
          y1={395.3}
          x2={365.01}
          y2={395.3}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ad"
          x1={163.59}
          y1={121.23}
          x2={244.16}
          y2={121.23}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__ae"
          x1={190.12}
          y1={401.87}
          x2={243.04}
          y2={401.87}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__af"
          x1={352.73}
          y1={393.09}
          x2={438.7}
          y2={393.09}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__ag"
          x1={164.75}
          y1={152.49}
          x2={244.16}
          y2={152.49}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__ah"
          x1={171.45}
          y1={451.31}
          x2={220.58}
          y2={451.31}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__ai"
          x1={122.56}
          y1={92.8}
          x2={218.21}
          y2={92.8}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__aj"
          x1={110.89}
          y1={61.98}
          x2={117.17}
          y2={61.98}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ak"
          x1={260.86}
          y1={234.01}
          x2={383.68}
          y2={234.01}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__al"
          x1={173.31}
          y1={65.21}
          x2={249.69}
          y2={65.21}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__am"
          x1={244.16}
          y1={137.39}
          x2={322.99}
          y2={137.39}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__an"
          x1={110.89}
          y1={54.03}
          x2={157.95}
          y2={54.03}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ao"
          x1={146.7}
          y1={49.04}
          x2={157.95}
          y2={49.04}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__ap"
          x1={139.17}
          y1={64.57}
          x2={157.95}
          y2={64.57}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__aq"
          x1={146.72}
          y1={23.3}
          x2={173.31}
          y2={23.3}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__ar"
          x1={146.7}
          y1={35.86}
          x2={146.75}
          y2={35.86}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__at"
          x1={168.54}
          y1={23.3}
          x2={179.03}
          y2={23.3}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__au"
          x1={117.17}
          y1={68.48}
          x2={119.99}
          y2={68.48}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__av"
          x1={78.47}
          y1={101.56}
          x2={135.7}
          y2={101.56}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__aw"
          x1={74.69}
          y1={105.87}
          x2={119.52}
          y2={105.87}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__ax"
          x1={74.52}
          y1={78.12}
          x2={110.89}
          y2={78.12}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__ay"
          x1={74.52}
          y1={86.04}
          x2={110.35}
          y2={86.04}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__az"
          x1={84.29}
          y1={114.07}
          x2={126.64}
          y2={114.07}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__ba"
          x1={126.64}
          y1={108.72}
          x2={128.83}
          y2={108.72}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bb"
          x1={122.56}
          y1={115.26}
          x2={126.64}
          y2={115.26}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bc"
          x1={120.02}
          y1={72.29}
          x2={120.04}
          y2={72.29}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bd"
          x1={133.87}
          y1={65.78}
          x2={139.21}
          y2={65.78}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bf"
          x1={120.02}
          y1={68.55}
          x2={133.92}
          y2={68.55}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bh"
          x1={110.89}
          y1={74.75}
          x2={120.04}
          y2={74.75}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bj"
          x1={110.35}
          y1={77.29}
          x2={110.94}
          y2={77.29}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bl"
          x1={78.37}
          y1={79.84}
          x2={139.17}
          y2={79.84}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bm"
          x1={0}
          y1={217.86}
          x2={204.89}
          y2={217.86}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__bn"
          x1={0}
          y1={246.37}
          x2={204.89}
          y2={246.37}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__bo"
          x1={0}
          y1={222.13}
          x2={204.89}
          y2={222.13}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__bp"
          x1={47.9}
          y1={222.13}
          x2={149.23}
          y2={222.13}
          xlinkHref="#prefix__a"
        />
        <style>
          {
            '.prefix__ar{fill:url(#prefix__ar)}.prefix__at{fill:#25204b}.prefix__be{fill:url(#prefix__bd)}.prefix__bf{fill:url(#prefix__bf)}.prefix__bg{fill:url(#prefix__bh)}.prefix__bh{fill:url(#prefix__bj)}'
          }
        </style>
      </defs>
      <path
        fill="url(#prefix__a)"
        d="M275.55 209.13l-14.69-34.73-33.49-4.34-18.67 39.07 38.41 63.85 18.67 15.72 10.8-77.13-1.03-2.44z"
      />
      <path
        fill="url(#prefix__b)"
        d="M243.04 351.46l2.46-5.64 20.28-57.12-18.67-15.72-4.07 78.48z"
      />
      <path
        fill="url(#prefix__c)"
        d="M322.99 182.47l-78.83-47.54 16.7 39.47 62.13 8.07z"
      />
      <path
        d="M209.39 349.6c.75 9.6 1.44 18 1.56 18.19l-1.56-18.19z"
        fill="url(#prefix__d)"
      />
      <path
        fill="url(#prefix__e)"
        d="M304.1 324.07l28.98-30.46-56.5-82.04-10.8 77.13 38.32 35.37z"
      />
      <path
        fill="url(#prefix__f)"
        d="M244.16 134.93l-16.79 35.13 33.49 4.34-16.7-39.47z"
      />
      <path
        fill="url(#prefix__g)"
        d="M342.37 309.42l-9.29-15.81-28.98 30.46 25.54 88.43 26.53-79.59-13.8-23.49z"
      />
      <path
        d="M265.78 288.7l-20.28 57.12 19.16 35.53c22 25.81 52.94 38.61 52.94 38.61l12-7.46-25.55-88.43z"
        fill="url(#prefix__h)"
      />
      <path
        d="M247.11 273l-38.41-63.87.69 2.44 5.29 59.43-7.46 50.11s1.15 15.38 2.17 28.48l1.61 18.2 32-16.33z"
        fill="url(#prefix__i)"
      />
      <path
        fill="url(#prefix__j)"
        d="M167.52 468.01l38.32-2.95-34.39-11.79-3.93 14.74z"
      />
      <path fill="url(#prefix__k)" d="M416.27 424.29z" />
      <path
        fill="url(#prefix__l)"
        d="M384.13 495.92l113.28-27.91H422.1l-37.97 27.91z"
      />
      <path
        d="M399.6 461.44L389.08 468c.44-.27 108.33 0 108.33 0l-27.64-55.39L430 442.46z"
        fill="url(#prefix__m)"
      />
      <path
        d="M258.9 457.69h38.81l-27.51-23.58c-2.95 1.47-11.3 23.58-11.3 23.58z"
        fill="url(#prefix__n)"
      />
      <path
        d="M383.68 293.61h-50.6l9.29 15.81 13.8 23.49 65.83.49c-2.46-4.91-38.32-39.79-38.32-39.79z"
        fill="url(#prefix__o)"
      />
      <path
        d="M438.7 391.37s-10.82 18.6-22.43 32.92L430 442.46l39.79-29.84z"
        fill="url(#prefix__p)"
      />
      <path
        fill="url(#prefix__q)"
        d="M215.91 79.68l-42.6-33.09-26.56-10.7 11.2 26.33 60.26 18.3 25.95 54.41 5.53-42.82-33.78-12.43z"
      />
      <path fill="url(#prefix__r)" d="M128.83 106.44l6.87-14.33-6.87 14.33z" />
      <path
        fill="url(#prefix__s)"
        d="M365.01 424.29L422 333.4l-65.83-.49 8.84 91.38z"
      />
      <path d="M120 72.11v.12z" fill="url(#prefix__t)" />
      <path
        fill="url(#prefix__u)"
        d="M396.65 468.01h-7.57l-5.4 30.46 69.51-5.53 44.22-24.93H396.65z"
      />
      <path d="M152.31 419.78s-.02.02 0 0z" fill="url(#prefix__v)" />
      <path
        d="M207.21 321.12l7.47-50.12-5.3-59.44-.69-2.44-23 48.12 21.77 67.17c-.15-2.06-.25-3.29-.25-3.29z"
        fill="url(#prefix__w)"
      />
      <path fill="url(#prefix__x)" d="M399.6 461.44l-10.52 6.57" />
      <path
        d="M208.7 209.13l18.67-39.07-62.62-8.13c0 2.22-.08 4.37-.18 6.41-2 44.21 21.13 88.91 21.13 88.91l23-48.12z"
        fill="url(#prefix__y)"
      />
      <rect
        x={218.97}
        y={401.06}
        width={19.87}
        transform="rotate(-77.38 228.904 401.062)"
        fill="url(#prefix__z)"
      />
      <path
        d="M264.66 381.35l-15 10h-18.59l-4.34 19.39h73.36s-25.55-17.23-35.43-29.39z"
        fill="url(#prefix__aa)"
      />
      <path
        fill="url(#prefix__ab)"
        d="M297.71 457.69h4.91l50.11-4.91 12.28-28.49-67.3 33.4z"
      />
      <path
        d="M356.17 332.91l-26.53 79.59-12 7.46s-44.46 12.68-47.4 14.15l27.51 23.58 67.3-33.4z"
        fill="url(#prefix__ac)"
      />
      <path
        d="M218.21 80.52l-54.62 42.86s1.4 21.24 1.16 38.55l79.41-27z"
        fill="url(#prefix__ad)"
      />
      <path
        d="M231.07 391.37l5.72-25.55 6.21-14.36-32 16.33c.3.49-20.83 69.76-20.83 69.76l30.46 14.74 1.47-20.64 4.68-20.89z"
        fill="url(#prefix__ae)"
      />
      <path
        d="M416.27 424.29c11.61-14.32 22.43-32.92 22.43-32.92s-14.24-53.06-16.7-58l-57 90.89-12.28 28.49s29.48-11.3 43.72-12.28c5.4-.34 12.76-7.47 19.83-16.18z"
        fill="url(#prefix__af)"
      />
      <path
        fill="url(#prefix__ag)"
        d="M244.16 134.93l-79.41 27 62.62 8.13 16.79-35.13z"
      />
      <path
        fill="url(#prefix__ah)"
        d="M190.12 437.55l-7.37 4.91-11.3 10.81 34.39 11.79 14.74-12.77-30.46-14.74z"
      />
      <path
        fill="url(#prefix__ai)"
        d="M157.95 62.22l-18.78 4.69-3.47 25.2-6.87 14.33-2.19 4.57-4.08 8.5 41.03 3.87 54.62-42.86-60.26-18.3z"
      />
      <path
        d="M117.17 64.86a13.21 13.21 0 00-6.28-5.75 17.13 17.13 0 016.28 5.75z"
        fill="url(#prefix__aj)"
      />
      <path
        d="M323 182.46l-62.13-8.06 15.72 37.17 56.5 82h50.6c-6.88-22.6-51.09-82-56-99.73z"
        fill="url(#prefix__ak)"
      />
      <path
        d="M215.91 79.78l33.78 12.44-9.95-14.85c-22.6-38-61.33-39.17-61.33-39.17l-5.1 8.5z"
        fill="url(#prefix__al)"
      />
      <path
        fill="url(#prefix__am)"
        d="M249.69 92.22l-5.53 42.81 78.83 47.54-32.65-53.92-40.65-36.43z"
      />
      <path
        d="M146.7 35.87l-33.33 17-2.5 6.29a13.21 13.21 0 016.28 5.75 18.36 18.36 0 012.85 7.2v.12l13.9-7.47.23-.13 5.06 2L158 62.22z"
        fill="url(#prefix__an)"
      />
      <path
        fill="url(#prefix__ao)"
        d="M146.75 35.89l-.05-.02 11.25 26.35-11.2-26.33z"
      />
      <path
        fill="url(#prefix__ap)"
        d="M139.17 66.91l18.78-4.69-18.74 4.42-.04.27z"
      />
      <path
        fill="url(#prefix__aq)"
        d="M173.31 46.59L168.54 0l-21.82 35.83.03.06 26.56 10.7z"
      />
      <path className="prefix__ar" d="M146.75 35.89l-.03-.06-.02.04.05.02z" />
      <path className="prefix__ar" d="M146.75 35.89l-.03-.06-.02.04.05.02z" />
      <path
        fill="url(#prefix__at)"
        d="M178.41 38.09l.62-22.31-2.7-6.26L168.54 0l4.77 46.59 5.1-8.5z"
      />
      <path
        className="prefix__at"
        d="M120 72.23v-.12a24.72 24.72 0 00-2.82-7.25 17.13 17.13 0 00-6.28-5.75l-3.66 9.22 3.66 8.82z"
      />
      <path
        d="M120 72.11a18.36 18.36 0 00-2.82-7.25 24.72 24.72 0 012.82 7.25z"
        fill="url(#prefix__au)"
      />
      <path
        fill="url(#prefix__av)"
        d="M78.47 94.83l48.17 16.18 9.06-18.9-57.23 2.72z"
      />
      <path
        fill="url(#prefix__aw)"
        d="M78.47 94.83l-3.78 9.53 9.6 12.56 35.23-8.29-41.05-13.8z"
      />
      <path
        fill="url(#prefix__ax)"
        d="M110.89 77.14l-3.66-8.81L74.52 87.9l35.83-10.46.54-.3z"
      />
      <path fill="#ef7f1e" d="M78.41 94.72l.3-.02" />
      <path
        fill="url(#prefix__ay)"
        d="M110.35 77.44L74.52 87.9l3.84 6.74 31.99-17.2z"
      />
      <path
        fill="url(#prefix__az)"
        d="M119.52 108.63l-35.23 8.29 38.27 2.59 4.08-8.5-7.12-2.38z"
      />
      <rect x={125.2} y={108.72} width={5.07} fill="url(#prefix__ba)" />
      <path fill="url(#prefix__bb)" d="M126.64 111.01l-4.08 8.5 4.08-8.5z" />
      <path d="M120 72.23a.43.43 0 000 .11v-.11z" fill="url(#prefix__bc)" />
      <path
        className="prefix__be"
        d="M139.1 66.93l.07-.02.04-.27-5.06-2.01-.24.13-.04.1 5.23 2.07z"
      />
      <path
        className="prefix__be"
        d="M139.1 66.93l.07-.02.04-.27-5.06-2.01-.24.13-.04.1 5.23 2.07z"
      />
      <path className="prefix__bf" d="M133.87 64.86v-.1L120 72.23v.11z" />
      <path className="prefix__bf" d="M133.87 64.86v-.1L120 72.23v.11z" />
      <path
        className="prefix__bg"
        d="M120 72.34a.43.43 0 010-.11l-9.13 4.92v.11z"
      />
      <path
        className="prefix__bg"
        d="M120 72.34a.43.43 0 010-.11l-9.13 4.92v.11z"
      />
      <path
        className="prefix__at"
        d="M78.41 94.72l-.05-.08-3.84-6.74-6.71 4.01.18 7.86 6.7 4.59 3.76-9.48.01-.02.01-.03-.06-.11z"
      />
      <path className="prefix__bh" d="M110.94 77.26l-.05-.12-.54.3.59-.18z" />
      <path className="prefix__bh" d="M110.94 77.26l-.05-.12-.54.3.59-.18z" />
      <path
        fill="url(#prefix__bl)"
        d="M139.1 66.93l-5.23-2.07-13.83 7.48-9.1 4.92-.59.18-31.99 17.2.11.19 57.23-2.72 3.47-25.2-.07.02z"
      />
      <path
        fill="url(#prefix__bm)"
        d="M0 220.44L30.95 234l20.51-1.97-3.56-30.31L0 220.44z"
      />
      <path
        fill="url(#prefix__bn)"
        d="M171.45 219.76l-31.71 22.79-88.28-10.52 95.24 40.95 39-15.73-14.25-37.49z"
      />
      <path
        fill="url(#prefix__bo)"
        d="M47.9 201.72l3.56 30.31 88.28 10.52-91.84-40.83z"
      />
      <path
        fill="url(#prefix__bp)"
        d="M47.9 201.72l3.56 30.31 88.28 10.52-91.84-40.83z"
      />
    </svg>
  );
}

export default FoxPoint;
